import { injectIntl } from 'react-intl';
import withLabel from 'admin-components/components/withLabel/withLabel';

import DiscountCard from './DiscountCard';

export default withLabel(injectIntl(DiscountCard));
